/* eslint-disable */
require('./accordion')
require('./acoustic-guitar')
require('./amp')
require('./amplificator')
require('./banjo')
require('./bass-guitar')
require('./boombox')
require('./chimes')
require('./conga')
require('./contrabass')
require('./cymbals')
require('./domra')
require('./drum-set')
require('./drum')
require('./drumsticks')
require('./dual-guitar')
require('./electric-guitar-1')
require('./electric-guitar-2')
require('./electric-guitar-3')
require('./electric-guitar')
require('./electronics')
require('./fluglehorn')
require('./flute')
require('./fork')
require('./guitar-1')
require('./guitar')
require('./harmonica')
require('./harp')
require('./hfner-5001-bass-guitar')
require('./hi-hat')
require('./laptop')
require('./maracas')
require('./metronome')
require('./midi')
require('./monitor')
require('./music-stand')
require('./music')
require('./musical-notes')
require('./pedal-for-guitar')
require('./pianino')
require('./piano')
require('./saxophone')
require('./score')
require('./sound-card')
require('./sound-control')
require('./synthetiser')
require('./tam-tam')
require('./tambourine')
require('./timbrel')
require('./triangle')
require('./trombone')
require('./trommel')
require('./trumpet')
require('./ukelele')
require('./violin')
require('./violoncello')
require('./voltorna')
require('./xylophone')
